"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("..");
var element_1 = require("../element");
var range_chart_1 = require("./range-chart");
/**
 * Data format: {value, name}[]
 */
var WaterfallChart = /** @class */ (function (_super) {
    __extends(WaterfallChart, _super);
    function WaterfallChart() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cachedMax = 0;
        return _this;
    }
    WaterfallChart.prototype.defaultOptions = function () {
        return __assign(__assign({}, _super.prototype.defaultOptions.call(this)), { _minValueFunc: function (d) { return d.value > 0 ? d.from : d.from + d.value; }, _maxValueFunc: function (d) { return d.value > 0 ? d.from + d.value : d.from; }, _valueFunc: function (d) { return d.value; }, _categoryFunc: function (d) { return d.name; } });
    };
    WaterfallChart.prototype.init = function () {
        _super.prototype.init.call(this);
        this._lines = this._groups.appendT(element_1.Line).options({
            stroke: "#fff",
        });
        this._labelsMax.options({
            _text: function (d, i, g) { return i === g.length - 1 ? d.from : d.value; },
        });
        this._labelsMin.options("_display", false);
    };
    WaterfallChart.prototype.prepare = function () {
        this._processData();
        _super.prototype.prepare.call(this);
        this.setupProxy({
            label: "_labelsMax",
            line: "_lines",
        });
    };
    WaterfallChart.prototype.postOptionsUpdate = function () {
        var _this = this;
        _super.prototype.postOptionsUpdate.call(this);
        var gravity = this.getOption("_gravity");
        var isHorizontal = gravity === __1.Gravity.Left || gravity === __1.Gravity.Right;
        var isInversed = gravity === __1.Gravity.Bottom || gravity === __1.Gravity.Right;
        /**
         * Get the anchor for each label.
         * @param isMinus whether this bar represents a decreasement.
         */
        var getAnchor = function (isMinus) {
            return (isHorizontal ? 4 /* Middle */ : (isInversed === isMinus ? 8 /* Bottom */ : 2 /* Top */)) |
                (isHorizontal ? (isInversed === isMinus ? 64 /* Right */ : 16 /* Left */) : 32 /* Center */);
        };
        this._labelsMax.options({
            // For the last bar, always display as increasement
            _anchor: function (d, i, g) { return getAnchor(d.value < 0 !== (i === g.length - 1)); },
            _relatedTo: function (d, i, g) { return getAnchor(d.value < 0 !== (i === g.length - 1)); },
        });
        var getLineY = function (d, i) { return d.value > 0 === isInversed ? 0 : _this._getWidthOrHeight(isHorizontal)(d, i); };
        this._lines.options({
            x1: function (_) { return _this._thick; },
            y1: getLineY,
            x2: function (_) { return _this._thick + _this._gap; },
            y2: getLineY,
            visibility: function (d, i, g) { return i === g.length - 1 ? "hidden" : "visible"; },
        });
    };
    WaterfallChart.prototype._getBarCount = function () {
        // We added one extra bar
        return this.datum.length + 1;
    };
    WaterfallChart.prototype._getMax = function () {
        var maxVal = this.getOption("_maxValue");
        return maxVal > 0 ? maxVal : this._cachedMax;
    };
    WaterfallChart.prototype._getMin = function () {
        return 0;
    };
    /**
     * Since this chart is extended from range chart, we need to calclulate the "from" and "to"
     * value for each bar. Hence this._groups has the fixed data format defined here:
     * {from: number, value: number, label:string , data: any}
     */
    WaterfallChart.prototype._processData = function () {
        if (!(this.datum instanceof Array && this.datum.length >= 2)) {
            return;
        }
        var valueFunc = this.getOption("_valueFunc");
        var categoryFunc = this.getOption("_categoryFunc");
        var data = [];
        var total = 0;
        for (var i = 0; i < this.datum.length; i++) {
            var val = valueFunc(this.datum[i], i);
            data.push({
                from: total,
                value: val,
                label: categoryFunc(this.datum[i], i),
                data: this.datum[i],
            });
            total += val;
            if (total > this._cachedMax) {
                this._cachedMax = total;
            }
        }
        // Add the final (total) value as an extra bar.
        data.push({
            from: total, value: -total, label: "Total", data: null,
        });
        this._groups.data(data);
    };
    return WaterfallChart;
}(range_chart_1.RangeChart));
exports.WaterfallChart = WaterfallChart;
//# sourceMappingURL=waterfall-chart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/waterfall-chart.js
// module id = 1144
// module chunks = 0 1